import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {template} from './template';
import css from './index.styl?inline';

interface RadioButtonJsxProps {
  attrs?: {
    disabled?: boolean;
    focused?: boolean;
    icon?: string;
    selected?: boolean;
    theme?: string;
  };
}

export class RadioButton extends Component<EmptyObj, RadioButtonJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<RadioButtonJsxProps['attrs']> {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      focused: `boolean`,
      icon: `string`,
      selected: `boolean`,
      theme: {type: `string`, default: `primary`},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }
}

export const RadioButtonEl = defineAndMakeJsxFactory<RadioButtonJsxProps>(`mp-radio-button`, RadioButton);
